import AbstractViewFactory from '@/core/view/abstractViewFactory';
import ContentModel from '@/app/model/contentModel';
import LifespanView from '@/app/views/lifespan/lifespanView';
import PersonComparisonView from '@/app/views/person/personComparisonView';
import CohortTableView from '@/app/views/cohort/cohortTableView';
import RegionalComparisonView from '@/app/views/regional/regionalComparisonView';

const _VIEWS = '';


class ViewFactory extends AbstractViewFactory {

    constructor() {
        super();
        

        this._viewMap = {
            'lifespan': LifespanView,
            'regionalcomparison': RegionalComparisonView,
            'cohorttable': CohortTableView,
            'personcomparison': PersonComparisonView
        };
    }

    getViewDataByID(id) {

        let val = ContentModel.instance.getViewDataByID(id);
        return val;
    }

}

export default ViewFactory;
